import Image from 'next/image';
import Link from 'next/link';

export default function CorporateHeader() {
  return (
    <header className='flex items-center fixed h-12 px-4 bg-gray-400 dark:bg-gray-900 top-0 left-0 right-0 z-20 shadow-md'>
      <Link href='/' className='flex items-center gap-1'>
        <div className='bg-slate-200 dark:bg-slate-300 rounded-full w-8 h-8'>
          <Image
            src='/trainme.webp'
            alt='Logo'
            width={48}
            height={48}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </div>
        <h1 className='text-emerald-700 h1 mx-0'>TrainMe</h1>
      </Link>
    </header>
  );
}
